import { useTranslation } from 'react-i18next';
import ApplePayWhite from '../../../assets/ApplePayWhite.svg';

import { performValidation, sendPaymentToken, orderUpdateApi } from '../../../api/apigeeApi';

import './ApplePayment.scss';

interface Props {
    shoppingCart: any;
    rtl: boolean;
    selectRadioOption: string;
}

const win: any = window;
const failureReturnUrl = `${win.returnUrl}&status=failure`;

function ApplePayment({ shoppingCart, selectRadioOption }: Props) {
    const { t } = useTranslation();

    const cartTotalPrice = shoppingCart && shoppingCart.cartTotalPrice.filter((cart: any) => cart.priceType === "Onetime")[0]

    const handleApplePay = () => {
        console.log("Apple Btn Click...");

        const rawAmount = Number(cartTotalPrice?.price?.taxIncludedAlteredAmount?.value);
        const amount = isNaN(rawAmount) ? "0.00" : rawAmount?.toFixed(2);

        console.log("Amount:", amount);

        const lineItems = [{
            amount: amount,
            label: "Pay Amount",
            type: "final"
        }];

        const totals = {
            amount: amount,
            label: "Total Amount",
            type: "final"
        };

        const paymentRequest = {
            currencyCode: "SAR",
            countryCode: "SA",
            total: totals,
            lineItems,
            supportedNetworks: ["mada", "masterCard", "visa"],
            merchantCapabilities: ["supports3DS", "supportsCredit", "supportsDebit"],
        };

        const session = new win.ApplePaySession(5, paymentRequest);
        console.log("session started...", session);

        handleEventsForApplePay(session, paymentRequest);

        session.begin();
    }

    const handleEventsForApplePay = (session: any, paymentRequest: any) => {
        session.onvalidatemerchant = (event: any) => {
            console.log("Start validating payment..");

            performValidation(event.validationURL)
                .then((res) => res.json())
                .then((data) => {
                    console.log("Validating data...", data);
                    const merchantSession = data.data;
                    if (merchantSession) {
                        session.completeMerchantValidation(merchantSession);
                    } else {
                        console.log("Error during validating merchant", merchantSession);
                    }
                    try {
                        win.MixpanelTracker?.trackEvent("Payment Initiated", { payment_method: "ApplePay" });
                    } catch (e) {
                        console.log("Mixpanel Error:", e);
                    }
                }).catch(() => {
                    window.location.href = failureReturnUrl
                });
        };

        session.onshippingmethodselected = () => {
            console.log("onshippingmethodselected ...");
            const { total, lineItems } = paymentRequest;
            const newTotal = total;
            const newLineItems = lineItems;
            session.completeShippingMethodSelection(newTotal, newLineItems);
        };

        session.onpaymentmethodselected = () => {
            console.log("onpaymentmethodselected ...");
            session.completePaymentMethodSelection({ newTotal: paymentRequest.total, newLineItems: paymentRequest.lineItems });
            console.log("shipping onpaymentmethodselected..");
        };

        session.onpaymentauthorized = (event: any) => {
            const paymentData = event.payment
            sendPaymentToken(paymentData.token)
                .then((res) => res.json())
                .then((data) => {
                    console.log("Payment Authorizated...", data);

                    let status;
                    const success = data.status.statusCode === "MBE_000" && ["00", "0"].includes(data.data.responseCode);
                    if (success) {
                        status = session.STATUS_SUCCESS;
                    } else {
                        status = session.STATUS_FAILURE;
                        orderUpdateApi(data);
                        try {
                            win.MixpanelTracker?.trackEvent("Payment Failed", {
                                error_code: data.status.statusCode,
                                error_message: data.data.responseMessage,
                            });
                        } catch (e) {
                            console.log("Mixpanel Error:", e);
                        }
                    }

                    session.completePayment(status);
                    console.log("payment Status" + status);

                    if (win.returnUrl) {
                        window.location.href = win.returnUrl + (success ? "&status=success&scode=00" : "&status=failure");
                    } else {
                        const url = window.location.href.split("?")[0];
                        const reloadUrl = `${url}?codPayStatus=${success ? "success" : "error"}`;
                        window.location.href = reloadUrl;
                    }
                });
        };

        session.onerror = (event: any) => {
            console.error("Apple Pay Error:", event);
        };
    }

    return (
        <div className='ApplePayment__Container' style={selectRadioOption === 'applePay' ? { display: 'block' } : { display: 'none' }}>
            <div className='Payment__amount'>
                <div className='typography'>{t("TotalAmount")}: <span id="appleTotalAmount">{cartTotalPrice && cartTotalPrice.price.taxIncludedAlteredAmount.value} {cartTotalPrice && cartTotalPrice.price.taxIncludedAlteredAmount.unit}</span></div>
            </div>

            <button className='apple-pay-button' id="applepaybtn" onClick={handleApplePay}>
                {t("Pay_with")} <img src={ApplePayWhite} alt='apple-logo' />
            </button>
        </div>
    )
}

export default ApplePayment;